export default "__VITE_ASSET__0hBHo29J__"